import store from "@/store";
import { capitalize } from "@/filters";
import $appConfig from "@/config/app.config";

import { RESPONSE_CODES } from "@/constants";
import { isEmpty, removeUnderscore } from "@/utils/common.utils";
import { errors as errorMessages } from "@/dictionary";

const { snackbar } = $appConfig;

/**
 * Intercepts all api request which are sent using the axios instance globally
 * @param {Object} config request
 * @returns Api request
 */
export const requestInterceptor = (config) => {
  const token = store.getters["auth/token"];

  // Adds the token in the request header if token is present in teh store
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

/**
 * Fetch and concat error message
 * @returns {String} Error message
 */
const concatMessage = (index, prop, errors) => {
  const errorName = capitalize(removeUnderscore(prop));
  return `${index + 1}: ${errorName} ${errors[prop][0] ?? ""}`;
};

/**
 * Iterates over error object and concats error messages into a single string
 * @param {Object} errors Object containing api error messages
 * @param {Object} snackbarError Object refference to be used to show error message in the snackbar
 */
const showErrorMessage = (errors, snackbarError) => {
  let message = errorMessages.common.msg;

  if (!isEmpty(errors)) {
    message = `${Object.keys(errors).reduce((acc, prop, index) => {
      return acc.concat(concatMessage(index, prop, errors), ".\n ");
    }, "")}`;
  }

  // Fallback common error message to be shown to the user
  snackbarError.message = message;
  store.dispatch("ui/setSnackbar", snackbarError);
};

/**
 * Intercepts all the api response error returned by the api's
 */
export const responseInterceptor = (error) => {
  let isUnauthorised = false;
  const isSnackbarHidden = store.getters["ui/isSnackbarHidden"];

  let snackbarError = {
    value: true && !isSnackbarHidden,
    message: "",
    type: snackbar.snackbarTypes.error,
  };
  if (error.response) {
    const statusCode = error.response?.status;
    // const { errors } = error.response.data;
    const { data } = error.response;

    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    switch (statusCode) {
      /**
       * Dispacthes an action in the store to logout the user if 401 status code
       */
      case RESPONSE_CODES.unAuthorised:
        isUnauthorised = true;
        store.dispatch("auth/logoutUser", isUnauthorised);
        break;

      /**
       * Handles errors of (404) status code
       */
      case RESPONSE_CODES.notFound:
        showErrorMessage(data, snackbarError);
        break;

      /**
       * Handles 400 error response case
       */
      case RESPONSE_CODES.badRequest:
      case RESPONSE_CODES.internalServerError:
        showErrorMessage(data, snackbarError);
        break;
    }
  } else {
    /**
     * Handles error case for network error
     *  @todo implement global exception handling
     *  @description dispatched an action in the store to mutate the state of snackbar in the ui module
     */
    snackbarError.message = error.message;
    store.dispatch("ui/setSnackbar", snackbarError);
  }
  return !isUnauthorised && Promise.reject(error);
};
